import { render, staticRenderFns } from "./BalanceCardRow.vue?vue&type=template&id=54e2bd9c&"
import script from "./BalanceCardRow.vue?vue&type=script&lang=js&"
export * from "./BalanceCardRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports